import { color as colorVar, space, type ColorToken, type SpaceToken } from "./tokens.ts";

export type DividerProps = { color?: ColorToken; inset?: SpaceToken };

export function Divider({ color = "border.subtle", inset }: DividerProps) {
  return (
    <div
      role="separator"
      className="b-divider"
      style={{ background: colorVar(color), marginLeft: inset === undefined ? undefined : space(inset), marginRight: inset === undefined ? undefined : space(inset) }}
    />
  );
}
